// extracted by mini-css-extract-plugin
export var typingIndicator = "_mb-0";